import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import homeEN from './locales/en/home.json';
import pageNotFoundEN from './locales/en/404.json';

const resources = {
	en: {
		home: homeEN,
		pageNotFound: pageNotFoundEN
	}
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		debug: false,
		initImmediate: false,
		ns: ['programstop-translation'],
		defaultNS: 'programstop-translation',
		react: {
			useSuspense: false,
			wait: true
		},
		resources,
		interpolation: {
			escapeValue: false
		}
	});
